/*
export function someMutation (state) {
}
*/
export const updateToken = (state, token) => {
  state.token = token
}
export const updateRefreshToken = (state, token) => {
  state.refreshToken = token
}
export const updateLoggedIn = (state, status) => {
  state.loggedIn = status
}
export const updateUser = (state, user) => {
  state.user = user ? { ...user } : user
}
export const updateUserTenant = (state, tenant) => {
  state.userTenant = tenant
}
export const updateUserFeatureFlags = (state, featureFlags) => {
  state.userFeatureFlags = { ...featureFlags }
}
export const updateProfileId = (state, profileId) => {
  state.profileId = profileId
}
export const updateUsername = (state, username) => {
  state.username = username
}
export const updateRolename = (state, rolename) => {
  state.rolename = rolename
}
export const updateMainFolderId = (state, mainFolderId) => {
  state.mainFolderId = parseInt(mainFolderId)
}
export const updateUserId = (state, userId) => {
  state.userId = parseInt(userId)
}
export const updateTasks = (state, tasks) => {
  state.tasks = tasks
}
export const updateNotifications = (state, notifications) => {
  state.notifications = notifications
}
export const updateNotificationsGroupedFirstRender = (
  state,
  notificationsGroupedFirstRender,
) => {
  state.notificationsGroupedFirstRender = notificationsGroupedFirstRender
}
export const updateNotificationsSettings = (state, settings) => {
  state.notificationsSettings = settings
}
export const setLoading = (state, payload) => {
  state.loading = payload
}
export const setBrowserNotifications = (state, payload) => {
  state.browserNotifications = payload
}
export const updateSurrogateLogin = (state, surrogateLogin) => {
  state.surrogateLogin = surrogateLogin
}
